import { all, call, fork, put, takeLatest, takeLeading } from "typed-redux-saga";
import { Action, addEditConfigurationDialogActions } from "./add-edit-configuration-dialog-store";
import { errorActions } from "src/components/error-viewer/error-store";
import { AttributeService, ConfiguratorService, Shared_AttributeOwnerEntityKinds, Shared_AttributeTypes, Shared_PictureResolutions, SystemPackageService } from "src/backend/openapi/v1";
import { productDetailsActions } from "src/pages/product-details/product-details-store";

export function* getSystemPackages() {
  try {
    const result = yield* call(SystemPackageService.getApiV1SystemPackage);
    yield put(addEditConfigurationDialogActions.getSystemPackagesSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(addEditConfigurationDialogActions.getSystemPackagesFail());
  }
}

export function* watchGetSystemPackages() {
  yield takeLeading(Action.GetSystemPackagesRequest, getSystemPackages);
}

export function* getProducts(action: ReturnType<typeof addEditConfigurationDialogActions.getProductsRequest>) {
  try {
    const result = yield* call(ConfiguratorService.postApiV1ConfiguratorProjectsGetProducts, action.payload.projectId, action.payload.data);

    yield put(addEditConfigurationDialogActions.getProductsSuccess(result));

    // fetch images
    const productPictures = result.map(x => x.primaryProductPictureId).filter(x => !!x) as string[];
    yield put(
      productDetailsActions.getMultipleProductPicturesRequest(productPictures, Shared_PictureResolutions.Medium, (isSuccess, data) => {
        if (isSuccess && data) addEditConfigurationDialogActions.updateProductPictures(data);
      })
    );
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(addEditConfigurationDialogActions.getProductsFail());
  }
}

export function* watchgetProducts() {
  yield takeLeading(Action.GetProductsRequest, getProducts);
}

export function* getAttributes(action: ReturnType<typeof addEditConfigurationDialogActions.getAttributesRequest>) {
  try {
    // server now applies the FilterAttribute/List/entityFilterId predicate that used to be done client-side
    const result = yield* call(AttributeService.getApiV1Attributes, Shared_AttributeOwnerEntityKinds.FilterAttribute, Shared_AttributeTypes.List, action.payload.attributeEntityFilterId);
    yield put(addEditConfigurationDialogActions.getAttributesSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(addEditConfigurationDialogActions.getAttributesFail());
  }
}

export function* watchGetAttributes() {
  yield takeLatest(Action.GetAttributesRequest, getAttributes);
}

export function* createOrUpdateConfigurationRequest(action: ReturnType<typeof addEditConfigurationDialogActions.createOrUpdateConfigurationRequest>) {
  try {
    // systemProductConfigurationItemId replaces projectLineItemId on the new model
    if (!action.payload.data.systemProductConfigurationItemId) {
      // eslint-disable-next-line @itk/undesired-code-alerter
      console.error("Missing system product configuration item id");
      throw Error("Something went wrong");
    }

    // Stray extra `undefined` arg here used to shift action.payload.data out of the requestBody
    // position, so no body (and no Content-Type) was ever sent - server rejected with 415.
    const result = yield* call(
      ConfiguratorService.putApiV1ConfiguratorSystemProductConfigurations,
      action.payload.data.systemProductConfigurationItemId, // renamed from projectLineItemId
      action.payload.data
    );
    action.payload.callBack(true, result);
  } catch (error) {
    yield put(errorActions.addError(error));
    action.payload.callBack(false);
  }
}

export function* watchcreateOrUpdateConfiguration() {
  yield takeLeading(Action.CreateOrUpdateConfigurationRequest, createOrUpdateConfigurationRequest);
}

export function* addEditConfigurationDialogSaga() {
  yield all([fork(watchGetSystemPackages), fork(watchgetProducts), fork(watchGetAttributes), fork(watchcreateOrUpdateConfiguration)]);
}
